import React, { useEffect, useRef, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { Link } from "react-router-dom";
import bgimage from '../../../../images/raw_material/default_rawmaterial.png';
import DatePanel from "react-multi-date-picker/plugins/date_panel";
import DatePicker, { DateObject } from "react-multi-date-picker";

import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from 'axios';

const AddHoliday = ({ show, onClose, refresh }) => {

    const baseURL = process.env.REACT_APP_API_BASE_URL;

    const [start_date, setStartDate] = useState('');
    const [end_date, setEndDate] = useState('');
    const [holiday_name, setHolidayName] = useState('');
    const [description, setdescription] = useState('');
    const [errors, setErrors] = useState({});

    const formatName = (name) => {
        return name.charAt(0).toUpperCase() + name.slice(1);
    };

    const handleStartDateChange = (dateValue) => {
        // Format the selected date to 'YYYY-MM-DD' and store it in the state
        if (dateValue) {
          const formattedDate = dateValue.format('YYYY-MM-DD');
          setStartDate(formattedDate);
        } else {
          setStartDate(null);
        }
    };

    const handleEndDateChange = (dateValue) => {
        // Format the selected date to 'YYYY-MM-DD' and store it in the state
        if (dateValue) {
          const formattedDate = dateValue.format('YYYY-MM-DD');
          setEndDate(formattedDate);
        } else {
          setEndDate(null);
        }
    };
    const [holidays, setHolidays] = useState([]); // store holiday data from API
    // Fetch holidays once on component mount
    useEffect(() => {
        axios.get(`${baseURL}/holiday`)
        .then(response => {
            // Assuming holidays are in response.data.data
            setHolidays(response.data.data || []);
        })
        .catch(error => {
            console.error('Error fetching holidays:', error);
        });
    }, []);


    // const validate = () => {
    //     const newErrors = {};
    //     const regex = /^[A-Za-z0-9 ]+$/;

    //     if (!holiday_name.trim()) {
    //         newErrors.name = "This Field is Required.";
    //         // return newErrors;
    //     } else if (!regex.test(holiday_name)) {
    //         newErrors.name = "Not a Valid Name";
    //         // return newErrors;
    //     }

    //     if (!start_date) {
    //         newErrors.sdate = "This Field is Required.";
    //     }

    //     return newErrors;
    // };

    const validate = () => {
        const newErrors = {};
        const regex = /^[A-Za-z0-9 ]+$/;

        if (!holiday_name.trim()) {
            newErrors.name = "This Field is Required.";
        } else if (!regex.test(holiday_name)) {
            newErrors.name = "Not a Valid Name";
        } else {
            const nameExists = holidays.some(
                h => h.holiday_reason.toLowerCase() === holiday_name.trim().toLowerCase()
            );
            if (nameExists) {
                newErrors.name = "Holiday name already exists.";
            }
        }

        if (!start_date) {
            newErrors.sdate = "This Field is Required.";
        } else {
            const inputDate = new Date(start_date).toISOString().slice(0, 10);

            const dateExists = holidays.some(h => {
                const datesArray = h.holiday_dates.split(',').map(d => d.trim());
                return datesArray.includes(inputDate);
            });
            if (dateExists) {
                newErrors.sdate = "Holiday date already exists.";
            }
        }

        return newErrors;
    };

    const handleSubmit = (event) => {
        event.preventDefault();

        const validationErrors = validate();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }

        const postData = {
            start_date: start_date,
            end_date: end_date,
            holiday_reason: holiday_name,
            description: description,
        }

        axios.post(`${baseURL}/holiday`, postData)
            .then(response => {
                onClose();
                refresh();
                // window.location.reload();
                toast.success("Holiday Created Successfully!");
            })
            .catch(error => {
                onClose();
                console.log(error);
                toast.error("Holiday Creation Failed");
            });
    };


    return (
        <Modal show={show} size="md">
            <div className="modal-content">
                <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
                    <h3 className="modal-title text-white">Create Holiday</h3>
                    <Button variant="" type="button" className="close px-6 py-2" data-dismiss="modal" onClick={onClose}>
                        <span className="text-white">×</span>
                    </Button>
                </div>
                <div className="modal-body">
                    <div className="row">

                        <div className="col-lg-12 mb-2">
                            <label className="text-black font-w500 fs-7">From Date<span className="required">*</span></label>
                            <div className='datepicker-wrapper d-flex'>
                                <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                <DatePicker placeholder='Select From Date'
                                    onChange={handleStartDateChange}
                                    format="DD-MM-YYYY"
                                />
                            </div>
                            {errors.sdate && <div className="text-danger fs-8 mt-1">{errors.sdate}</div>}
                        </div>

                        <div className="col-lg-12 mb-2">
                            <label className="text-black font-w500 fs-7">To Date</label>
                            <div className='datepicker-wrapper d-flex'>
                                <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                <DatePicker placeholder='Select To Date'
                                    onChange={handleEndDateChange}
                                    format="DD-MM-YYYY"
                                />
                            </div>
                        </div>

                        {/* <div className="col-lg-12 mb-2">
                            <label className="text-black font-w500 fs-7">Date<span className="required">*</span></label>
                            <div className='datepicker-wrapper d-flex'>
                                <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                <DatePicker multiple
                                    format={format}
                                    placeholder='Select Date'
                                    className="date-picker-wrapper"
                                    plugins={[<DatePanel />]}
                                />
                            </div>
                        </div> */}

                        <div className="col-lg-12 mb-2">
                            <label className="text-black font-w500 fs-7">Holiday Reason<span className="required">*</span></label>
                            <input type="text" className="form-control" placeholder="Enter Holiday Reason" 
                                maxLength={100}
                                value={holiday_name}
                                onChange={(e) => setHolidayName(formatName(e.target.value))} 
                            />
                            {errors.name && <div className="text-danger fs-8 mt-1">{errors.name}</div>}
                        </div>
                        <div className="col-lg-12 mb-2">
                            <label className="text-black font-w500 fs-7">Description</label>
                            <textarea rows={8} className="form-control" name="comment" placeholder="Description" 
                                maxLength={150}
                                value={description}
                                onChange={(e) => setdescription(formatName(e.target.value))}
                            />
                        </div>

                    </div>
                    <div className="d-flex align-items-center justify-content-end gap-3 mt-4 mb-4">
                        <Link type="submit" className="btn btn-sm btn-primary" onClick={handleSubmit}>Create Holiday <i className="fas fa-angle-double-right ms-2"></i></Link>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default AddHoliday;
